import React, { useEffect, useState, useContext } from 'react';
import { ConfigContext } from '../../DynamicForm/DynamicForm';
import { ErrorMessage } from "formik";
import Markdown from "markdown-to-jsx";
import { Field } from "formik";
import Required from "../../../../components/Required";
import { SectionHeader } from '../../../../components/sectionHeader/sectionHeader';
import { SelfieIcon, IDIcon, UploadIcon, CloseIcon, DocumentIcon } from '../../styles/assets/icons';
import ErrorBar from '../../../../components/ErrorBar';
import './SupportingDocsSection.scss';
import RadioField from '../../../../components/RadioField2/RadioField';
import SectionInstruction from '../../../../components/sectionInstruction/view';
import { GetLanguageText } from '../../../../languages/languages';
import { CheckLanguage } from '../../../../languages/languages';


export const SupportingDocsSection = ({ fileSubmissionAction, fileDeletionAction }) => {
    // state values
    const [error, giveError] = useState(false);
    const [screenWidth, setScreenWidth] = useState(0);
    const [fileError, setFileError] = useState({ status: false, errorDisplay: 'none' });

    // context object
    const { formik, validationValues, dbFormSpec, formType, devMode } = useContext(ConfigContext);

    // local variables
    const template = { section: validationValues.page.form.sections.supportingDocsSection, styles: { ...validationValues.page.form.styles } };
    const fileColor = dbFormSpec.color + '0d';
    const orgId = dbFormSpec.facility.orgId;
    const triPartiteOrg = orgId.includes('7042') || orgId.includes('7101') || orgId.includes('7239')

    function dragOverHandler(ev) {
        // Prevent default behavior (Prevent file from being opened)
        ev.preventDefault();
    }

    function dropHandler(ev) {
        // Prevent default behavior (Prevent file from being opened)
        ev.preventDefault();

        if (ev.dataTransfer.items) {
            // Use DataTransferItemList interface to access the file(s)
            for (var i = 0; i < ev.dataTransfer.items.length; i++) {
                // If dropped items aren't files, reject them
                if (ev.dataTransfer.items[i].kind === 'file') {
                    var file = ev.dataTransfer.items[i].getAsFile();
                    // console.log('... file[' + i + '].name = ' + file.name);
                    // console.log(ev.dataTransfer.items[i].getAsFile());
                    fileSubmissionAction(ev.dataTransfer.items[i].getAsFile());
                    formik.setFieldValue('supportingDoc', [...formik.values.supportingDoc, ev.dataTransfer.items[i].getAsFile()])
                    // console.log(ev.currentTarget.files[0]);
                    // fileSubmissionAction(ev.currentTarget.files[0]);
                }
            }
        } else {
            // Use DataTransfer interface to access the file(s)
            for (var i = 0; i < ev.dataTransfer.files.length; i++) {
                // console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
                // console.log(ev.dataTransfer.items);
                // console.log(ev.currentTarget.files);
            }
        }
    }

    useEffect(() => {
        // fileError.status && setFileError({...fileError, status: false})
        // setTimeout(()=>{fileError.status && setFileError({...fileError, status: false})}, 8000)
    }, [fileError.status]);

    useEffect(() => {
        setScreenWidth(document.getElementsByTagName('body')[0].clientWidth)
        window.onresize = () => {
            setScreenWidth(document.getElementsByTagName('body')[0].clientWidth)
        }
    }, []);


    if (dbFormSpec.idVerification && dbFormSpec.idVerification.active === false) {
        return (<></>);
    }

    const languageID = CheckLanguage(dbFormSpec);
    const languageText = GetLanguageText(languageID);

    if (dbFormSpec.idVerification && dbFormSpec.idVerification.UseCustom) {
        let TouchAndUploadText = dbFormSpec.idVerification.TouchAndUploadText || (languageID !== "default" ? languageText.IdentityVerification.instructions.TouchAndUpload
            : "Touch to upload files");
        let DragAndDropText = dbFormSpec.idVerification.DragAndDropText || (languageID !== "default" ? languageText.IdentityVerification.instructions.DragAndDrop
            : "Drag & drop or Click to browse");
        let uploadMsg = dbFormSpec.idVerification.uploadMsg || (languageID !== "default" ? languageText.IdentityVerification.instructions.OnlyPDFs
            : "Only PDFs and Images may be uploaded");
        let maxFileSizeMsg = dbFormSpec.idVerification.maxFileSizeMsg || (languageID !== "default" ? languageText.IdentityVerification.instructions.MaxSize
            : "Maximum file size is 15mb");
        let SectionTitleText = dbFormSpec.idVerification.SectionTitleText || (languageID !== "default" ? languageText.RepInfoSection.IdentityVerificationSection.sectionHeader
            : "Identity Verification");


        return (
            <div id="supportingDocSection" className="form-section">
                <div id="supportingDoc"></div>
                <SectionHeader sectionTitle={SectionTitleText} styles={{ color: dbFormSpec.color }} />
                {formik.errors.supportingDoc && formik.touched.supportingDoc &&
                    <ErrorBar message={formik.errors.supportingDoc} />
                }
                {fileError.status && <ErrorBar message={fileError.message} />}
                <div id='section-content'>

                    {
                        <div id='upload-instructions-and-field' style={formType === 'Representative' ? { marginTop: 40 } : {}}>
                            <div id='instructions-container'>
                                <label className='section-instruction subtitle1'> {dbFormSpec.idVerification.text} </label>
                                <div className="id-instructions">
                                    <div className="instruction-item body1" style={{ display: 'flex', marginBottom: 26 }}>
                                        <IDIcon />
                                        <p>{dbFormSpec.idVerification.id.label}</p>
                                    </div>
                                    {
                                        dbFormSpec.idVerification.selfie.active &&
                                        <div className="instruction-item body1" style={{ display: 'flex' }}>
                                            <SelfieIcon />
                                            <p>{dbFormSpec.idVerification.selfie.label}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div id='ID-file-input-container' className='file-input'>
                                <div className='file-input-instruction'>
                                    <UploadIcon />
                                    {screenWidth < 1024 ? <p className='body1'>{TouchAndUploadText} </p> : <p className='body1'> {DragAndDropText} </p>}
                                </div>

                                <input
                                    id="ID-file-input"
                                    multiple
                                    onDrop={(e) => { dropHandler(e) }}
                                    onDragOver={(e) => { dragOverHandler(e) }}
                                    name="supportingDoc"
                                    type="file"

                                    onChange={(event) => {
                                        event.preventDefault()
                                        devMode && console.log("File", event)

                                        const arrayOfFiles = Object.values(event.currentTarget.files);

                                        if (arrayOfFiles.some((file) => { return !['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'].includes(file.type) })) {
                                            setFileError({ status: 'size', message: uploadMsg })
                                        }
                                        if (arrayOfFiles.some((file) => { return file.size >= 15000000 })) {
                                            setFileError({ status: 'size', message: maxFileSizeMsg })
                                        }
                                        if (arrayOfFiles.length > 0 && arrayOfFiles.every((file) => { return file.size < 15000000 }) && arrayOfFiles.every((file) => { return ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'].includes(file.type) })) {
                                            giveError(false);
                                            setFileError({ ...fileError, status: false })

                                            if (!formik.getFieldProps("supportingDoc").value) {
                                                formik.setFieldTouched("supportingDoc", true, true);
                                                formik.setFieldValue("supportingDoc",

                                                    arrayOfFiles,
                                                );

                                            } else {
                                                formik.setFieldTouched("supportingDoc", true, true);
                                                formik.setFieldValue(
                                                    "supportingDoc",
                                                    formik
                                                        .getFieldProps("supportingDoc")
                                                        .value.concat(arrayOfFiles)
                                                );
                                                // console.log(event.currentTarget.files[0]);
                                                fileSubmissionAction(event.currentTarget.files[0]);
                                            }
                                        }
                                        else {
                                            giveError(template.section.fields.supportingDoc.validations.fileSize.message);
                                        }
                                        document.getElementById('ID-file-input').value = ''
                                    }}
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className='uploads-container'>
                    {formik.getFieldProps("supportingDoc").value &&
                        formik.getFieldProps("supportingDoc").value.map((item, index, array) => {

                            if (array[0] instanceof File) {
                                return (
                                    <UploadedFileTab item={item} formik={formik} fileDeletionAction={fileDeletionAction} key={index} />
                                );
                            }
                        })}

                </div>
            </div>
        );
    }

    // This is being overridden by the spec itself.


    if (languageID !== "default") {
        return (
            <div id="supportingDocSection" className="form-section">
                <SectionHeader sectionTitle={`${languageText.RepInfoSection.IdentityVerificationSection.sectionHeader}`} styles={{ color: dbFormSpec.color }} />
                <div id="supportingDoc"></div>
                {formik.errors.supportingDoc && formik.touched.supportingDoc &&
                    <ErrorBar message={formik.errors.supportingDoc} />
                }
                {fileError.status && <ErrorBar message={fileError.message} />}
                <div id='section-content'>
                    {
                        <div id='upload-instructions-and-field' style={formType === 'Representative' ? { marginTop: 40 } : {}}>
                            <div id='instructions-container'>
                                <label className='section-instruction subtitle1'> {dbFormSpec.idVerification.text} </label>
                                <div className="id-instructions">
                                    <div className="instruction-item body1" style={{ display: 'flex', marginBottom: 26 }}>
                                        <IDIcon />
                                        <p>{dbFormSpec.idVerification.id.label}</p>
                                    </div>

                                    {
                                        dbFormSpec.idVerification.selfie.active &&
                                        <div className="instruction-item body1" style={{ display: 'flex' }}>
                                            <SelfieIcon />
                                            <p>{dbFormSpec.idVerification.selfie.label}</p>
                                        </div>


                                    }
                                </div>
                            </div>
                            <div id='ID-file-input-container' className='file-input'>
                                <div className='file-input-instruction'>
                                    <UploadIcon />
                                    {screenWidth < 1024 ? <p className='body1'>{languageText.IdentityVerification.instructions.TouchAndUpload}</p> : <p className='body1'>{languageText.IdentityVerification.instructions.DragAndDrop}</p>}
                                </div>

                                <input
                                    id="ID-file-input"
                                    multiple
                                    onDrop={(e) => { dropHandler(e) }}
                                    onDragOver={(e) => { dragOverHandler(e) }}
                                    name="supportingDoc"
                                    type="file"

                                    onChange={(event) => {
                                        event.preventDefault()
                                        devMode && console.log("File", event)
                                        // console.log(Object.values(event.currentTarget.files));
                                        const arrayOfFiles = Object.values(event.currentTarget.files)

                                        // if (event.currentTarget.files[0] && event.currentTarget.files[0].size < 15000000) {

                                        if (arrayOfFiles.some((file) => { return !['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'].includes(file.type) })) {
                                            setFileError({ status: 'size', message: `${languageText.ErrorChecking.ValidatorText.fileType}` })
                                        }
                                        if (arrayOfFiles.some((file) => { return file.size >= 15000000 })) {
                                            setFileError({status: 'size', message: `${languageText.ErrorChecking.ValidatorText.fileSize}` })
                                        }
                                        if (arrayOfFiles.length > 0 && arrayOfFiles.every((file) => { return file.size < 15000000 }) && arrayOfFiles.every((file) => { return ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'].includes(file.type) })) {
                                            giveError(false);
                                            setFileError({ ...fileError, status: false })
                                            // console.log(formik.getFieldProps('supportingDoc').value)
                                            if (!formik.getFieldProps("supportingDoc").value) {
                                                formik.setFieldTouched("supportingDoc", true, true);
                                                formik.setFieldValue("supportingDoc",
                                                    // event.currentTarget.files[0],
                                                    arrayOfFiles,
                                                );
                                                // console.log(event.currentTarget.files);
                                                // fileSubmissionAction(event.currentTarget.files[0]);
                                            } else {
                                                formik.setFieldTouched("supportingDoc", true, true);
                                                formik.setFieldValue(
                                                    "supportingDoc",
                                                    formik
                                                        .getFieldProps("supportingDoc")
                                                        // .value.concat(event.currentTarget.files[0])
                                                        .value.concat(arrayOfFiles)
                                                );
                                                // console.log(event.currentTarget.files[0]);
                                                // console.log(event.currentTarget.files);
                                                fileSubmissionAction(event.currentTarget.files[0]);
                                                // }
                                            }
                                            // else if (arrayOfFiles.length < 3) {
                                            //   giveError('Please upload a maximum of three files')
                                        }
                                        else {
                                            giveError(template.section.fields.supportingDoc.validations.fileSize.message);
                                        }
                                        document.getElementById('ID-file-input').value = ''

                                    }}
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className='uploads-container'>
                    {formik.getFieldProps("supportingDoc").value &&
                        formik.getFieldProps("supportingDoc").value.map((item, index, array) => {
                            // console.log(array)
                            if (array[0] instanceof File) {
                                return (
                                    <UploadedFileTab item={item} formik={formik} fileDeletionAction={fileDeletionAction} key={index} />
                                );
                            }
                        })}

                </div>
            </div>
        );
    } else {


        return (
            <div id="supportingDocSection" className="form-section">
                <SectionHeader sectionTitle={'Identity Verification'} styles={{ color: dbFormSpec.color }} />
                <div id="supportingDoc"></div>
                {formik.errors.supportingDoc && formik.touched.supportingDoc &&
                    <ErrorBar message={formik.errors.supportingDoc} />
                }
                {fileError.status && <ErrorBar message={fileError.message} />}
                <div id='section-content'>


                    {
                        <div id='upload-instructions-and-field' style={formType === 'Representative' ? { marginTop: 40 } : {}}>
                            <div id='instructions-container'>
                                <label className='section-instruction subtitle1'> {dbFormSpec.idVerification.text} </label>
                                <div className="id-instructions">
                                    <div className="instruction-item body1" style={{ display: 'flex', marginBottom: 26 }}>
                                        <IDIcon />
                                        <p>{dbFormSpec.idVerification.id.label}</p>
                                    </div>

                                    {
                                        dbFormSpec.idVerification.selfie.active &&
                                        <div className="instruction-item body1" style={{ display: 'flex' }}>
                                            <SelfieIcon />
                                            <p>{dbFormSpec.idVerification.selfie.label}</p>
                                        </div>

                                    }
                                </div>
                            </div>
                            <div id='ID-file-input-container' className='file-input'>
                                <div className='file-input-instruction'>
                                    <UploadIcon />
                                    {screenWidth < 1024 ? <p className='body1'>Touch to upload files</p> : <p className='body1'>Drag & drop or Click to browse</p>}
                                </div>

                                <input
                                    id="ID-file-input"
                                    multiple
                                    onDrop={(e) => { dropHandler(e) }}
                                    onDragOver={(e) => { dragOverHandler(e) }}
                                    name="supportingDoc"
                                    type="file"

                                    onChange={(event) => {
                                        event.preventDefault()
                                        devMode && console.log("File", event)
                                        // console.log(Object.values(event.currentTarget.files));
                                        const arrayOfFiles = Object.values(event.currentTarget.files)

                                        // if (event.currentTarget.files[0] && event.currentTarget.files[0].size < 15000000) {

                                        if (arrayOfFiles.some((file) => { return !['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'].includes(file.type) })) {
                                            setFileError({ status: 'size', message: 'Only PDFs and Images may be uploaded' })
                                        }
                                        if (arrayOfFiles.some((file) => { return file.size >= 15000000 })) {
                                            setFileError({ status: 'size', message: 'Maximum file size is 15mb' })
                                        }
                                        if (arrayOfFiles.length > 0 && arrayOfFiles.every((file) => { return file.size < 15000000 }) && arrayOfFiles.every((file) => { return ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'].includes(file.type) })) {
                                            giveError(false);
                                            setFileError({ ...fileError, status: false })
                                            // console.log(formik.getFieldProps('supportingDoc').value)
                                            if (!formik.getFieldProps("supportingDoc").value) {
                                                formik.setFieldTouched("supportingDoc", true, true);
                                                formik.setFieldValue("supportingDoc",
                                                    // event.currentTarget.files[0],
                                                    arrayOfFiles,
                                                );
                                                // console.log(event.currentTarget.files);
                                                // fileSubmissionAction(event.currentTarget.files[0]);
                                            } else {
                                                formik.setFieldTouched("supportingDoc", true, true);
                                                formik.setFieldValue(
                                                    "supportingDoc",
                                                    formik
                                                        .getFieldProps("supportingDoc")
                                                        // .value.concat(event.currentTarget.files[0])
                                                        .value.concat(arrayOfFiles)
                                                );
                                                // console.log(event.currentTarget.files[0]);
                                                // console.log(event.currentTarget.files);
                                                fileSubmissionAction(event.currentTarget.files[0]);
                                                // }
                                            }
                                            // else if (arrayOfFiles.length < 3) {
                                            //   giveError('Please upload a maximum of three files')
                                        }
                                        else {
                                            giveError(template.section.fields.supportingDoc.validations.fileSize.message);
                                        }
                                        document.getElementById('ID-file-input').value = ''

                                    }}
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className='uploads-container'>
                    {formik.getFieldProps("supportingDoc").value &&
                        formik.getFieldProps("supportingDoc").value.map((item, index, array) => {
                            // console.log(array)
                            if (array[0] instanceof File) {
                                return (
                                    <UploadedFileTab item={item} formik={formik} fileDeletionAction={fileDeletionAction} key={index} />
                                );
                            }
                        })}

                </div>
            </div>
        );
    }
};



const UploadedFileTab = ({ item, formik, fileDeletionAction }) => {

    const roundedSize = item.size.toFixed(1)
    const bItem = item.size.toFixed(1) + 'b'
    const kbItem = (item.size / 1024).toFixed(1) + 'kb'
    const mbItem = (item.size / 1048576).toFixed(1) + 'mb'

    return (
        <li className="uploaded-file-tab" style={item.size > 1.5e+7 ? { background: '#C10000', color: 'white' } : { border: 'none' }}>
            <span>
                {item.name}
                {'   '}
                <span>{`${item.size < 1024 ? bItem : item.size < 104856 ? kbItem : mbItem}`}</span>
            </span>

            <CloseIcon onClick={() => {
                formik.validateForm();
                formik.setFieldValue(
                    "supportingDoc",
                    formik
                        .getFieldProps("supportingDoc")
                        .value.filter((x) => x != item)
                );
                fileDeletionAction(item.name);
                // console.log(document.getElementById('ID-file-input').value)
            }} />
        </li>
    )
}
